"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uiKit = require("@cian/ui-kit");
var _useDropdownControls = require("../useDropdownControls");
var _ErrorPopover = require("../../ErrorPopover");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Базовый дропдаун под нужды фильтров
 * Рендерит выпадающий список с помощью render-пропса
 * Рендерит мастер-компонент с помощью render-пропаса
 *  */
const Dropdown = props => {
  const {
    master,
    render,
    testId,
    classes = {},
    errorMessage = '',
    placement = 'bottom-start'
  } = props;
  const {
    handleClose,
    handleToggle,
    isOpen
  } = (0, _useDropdownControls.useDropdownControls)();
  const dropdownCss = React.useMemo(() => (0, _classnames.default)(styles['dropdown_base'], classes.dropdown || styles['dropdown']), [classes.dropdown]);
  return /*#__PURE__*/React.createElement(_uiKit.Popover, {
    open: isOpen,
    content: /*#__PURE__*/React.createElement(_uiKit.Outside, {
      onOutside: handleClose
    }, /*#__PURE__*/React.createElement("div", {
      className: dropdownCss,
      "data-testid": testId
    }, render({
      handleClose,
      handleToggle,
      isOpen
    }))),
    placement: placement,
    flip: false,
    preventOverflow: true
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['container'], classes.root)
  }, /*#__PURE__*/React.createElement(_ErrorPopover.ErrorPopover, {
    tooltipContent: errorMessage,
    placement: "bottom-start"
  }, master({
    handleClose,
    handleToggle,
    isOpen
  }))));
};
exports.Dropdown = Dropdown;
Dropdown.displayName = 'Dropdown';